import { Component, Input, OnInit, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-ui-preloader",
  templateUrl: "./preloader.component.html",
  styleUrls: ["./preloader.component.scss"],
})
export class PreloaderComponent {
  @Input() display: boolean = false;
  @Input() size: string = "40px";
  @Input() login: boolean = false;
  @Input() noBg: boolean = false;

  constructor() {
  }
}
